import type { ComponentProps } from "react";

const CloseIcon = ({
  color = "gray",
  strokeWidth = 2,
  ...props
}: ComponentProps<"svg">) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 2L10 10M2 10L10 2"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CloseIcon;
